import React from "react";
import { Flex, Text, Menu, MenuButton, MenuList, MenuItem, useColorModeValue } from "@chakra-ui/react";
import Card from "components/card/Card";
import IconBox from "components/icons/IconBox";
import { IconDownloadAll, IconDownloadOrigin, IconDownloadReceipt } from "components/icons/Icons";

interface DownloadActionsProps {
  onDownloadFiles: (type: string) => void;
  trackingDetails: any;
}

export const DownloadActions: React.FC<DownloadActionsProps> = ({
  onDownloadFiles,
  trackingDetails,
}) => {
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const shadow = useColorModeValue(
    "0px 4px 50px rgba(0, 0, 0, 0.1)",
    "0px 4px 50px rgba(0, 0, 0, 0.1)"
  );

  return (
    <Flex
      marginTop={{ md: "45px", base: "20px" }}
      columnGap={{ md: "36px", base: "15px" }}
      wrap="wrap"
      rowGap="20px"
    >
      <Card
        p="0"
        w="fit-content"
        cursor="pointer"
        onClick={() => onDownloadFiles("translation")}
        color="#2F80ED"
        _hover={{
          textDecoration: "underline",
        }}
      >
        <IconBox
          w="40px"
          h="40px"
          bg={boxBg}
          icon={<IconDownloadAll w="24px" h="24px" />}
        />
        <Text
          fontSize="14px"
          lineHeight="18px"
          color="#2F80ED"
          fontWeight="500"
          marginTop="10px"
        >
          Download <br />
          All Translations
        </Text>
      </Card>

      <Card
        p="0"
        w="fit-content"
        cursor="pointer"
        onClick={() => onDownloadFiles("origin")}
        color="#2F80ED"
        _hover={{
          textDecoration: "underline",
        }}
      >
        <IconBox
          w="40px"
          h="40px"
          bg={boxBg}
          icon={<IconDownloadOrigin w="24px" h="24px" />}
        />
        <Text
          fontSize="14px"
          lineHeight="18px"
          color="#2F80ED"
          fontWeight="500"
          marginTop="10px"
        >
          Download <br />
          Original File(s)
        </Text>
      </Card>

      {trackingDetails &&
        trackingDetails?.receiptLink?.length > 0 && (
          <>
            {trackingDetails.receiptLink?.length === 1 && (
              <Card
                p="0"
                w="fit-content"
                color="#2F80ED"
                cursor="pointer"
                _hover={{
                  textDecoration: "underline",
                }}
              >
                <a
                  href={trackingDetails.receiptLink[0].receipt_link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <IconBox
                    w="40px"
                    h="40px"
                    bg={boxBg}
                    icon={<IconDownloadReceipt w="24px" h="24px" />}
                  />
                  <Text
                    fontSize="14px"
                    lineHeight="18px"
                    color="#2F80ED"
                    fontWeight="500"
                    marginTop="10px"
                  >
                    Download <br />
                    Receipt
                  </Text>
                </a>
              </Card>
            )}
            {trackingDetails.receiptLink?.length > 1 && (
              <Menu>
                <MenuButton
                  padding={"0px"}
                  backgroundColor="transparent"
                  borderRadius="100px"
                >
                  <Card
                    p="0"
                    w="fit-content"
                    color="#2F80ED"
                    cursor="pointer"
                    _hover={{
                      textDecoration: "underline",
                    }}
                  >
                    <IconBox
                      w="40px"
                      h="40px"
                      bg={boxBg}
                      icon={<IconDownloadReceipt w="24px" h="24px" />}
                    />
                    <Text
                      fontSize="14px"
                      lineHeight="18px"
                      color="#2F80ED"
                      fontWeight="500"
                      marginTop="10px"
                      textAlign="left"
                    >
                      Download <br />
                      Receipts
                    </Text>
                  </Card>
                </MenuButton>
                <MenuList
                  boxShadow={shadow}
                  p="0px"
                  mt="10px"
                  borderRadius="20px"
                  bg={"#FFF"}
                  border="none"
                >
                  <Flex
                    flexDirection="column"
                    p="10px 20px"
                    fontSize={"14px"}
                    lineHeight="24px"
                    fontWeight={"400"}
                    color="black"
                  >
                    {trackingDetails.receiptLink.map(
                      (it: any, index: number) => (
                        <MenuItem
                          key={index}
                          _hover={{ bg: "none" }}
                          _focus={{ bg: "none" }}
                          borderRadius="8px"
                          padding="15px 0px"
                          borderBottom={
                            index <
                            trackingDetails.receiptLink.length - 1
                              ? "1px solid #F3F5F5"
                              : ""
                          }
                        >
                          <Text
                            fontSize="sm"
                            color="#2F80ED"
                            _hover={{
                              textDecoration: "underline",
                            }}
                          >
                            <a
                              href={it.receipt_link}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {it.detail?.includes(
                                "Paid for Notarization Service"
                              )
                                ? "Receipt for Notarization Service"
                                : it.detail?.includes(
                                    "Shipping Delivery"
                                  )
                                ? "Receipt for Two-Days Shipping Delivery"
                                : "Receipt for Expedite Translation"}
                            </a>
                          </Text>
                        </MenuItem>
                      )
                    )}
                  </Flex>
                </MenuList>
              </Menu>
            )}
          </>
        )}
    </Flex>
  );
};
